import React from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import moment from "moment";
import {
	FormGroup,
	FormControl,
	FormLabel,
} from "react-bootstrap";
import { DateRangePicker } from "react-dates";
import SubmitButton from "components/SubmitButton";
import InlineAlert from "components/InlineAlert";
import * as groupsActions from "actions/groupsActions";

class EmployeePlanOpener extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			start: this.props.start || "",
			end: this.props.end || "",
			group_id: this.props.group_id || "",
			isLoading: false,
			submitted: false,
			error: "",
		};
	}

	componentDidMount() {
		this.props.getAllGroups();
	}

	onDatesChange = (dates) => {
		var { startDate, endDate } = dates;

		if (startDate)
			startDate = startDate.format("YYYY-MM-DD");

		if (endDate)
			endDate = endDate.format("YYYY-MM-DD");

		this.setState({
			start: startDate,
			end: endDate,
		});
	};


	handleChange = (event) => {
		this.setState({
			[event.target.id]: event.target.value,
		});
	};

	checkValidField = (name) => {
		return (
			this.state.submitted &&
			this.state.errors[name] !== undefined &&
			this.state.errors[name] !== ""
		);
	};

	checkInvalidRange = () => {
		return (
			this.state.submitted &&
			(this.state.start === "" ||
				this.state.end === "" ||
				this.state.start === null ||
				this.state.end === null ||
				this.state.error !== "")
		);
	};

	// open plan in new window
	handleSubmit = async (event) => {
		event.preventDefault();
		const { group_id, start, end, error } = this.state;
		const props = this.props;

		if (group_id && start && end && error === "") {
			const newURL = `/plans/${group_id}/${start}@${end}`;
			// Abrir en nueva ventana
			window.open(newURL, '_blank');
			props.handleClose();
		}

		this.setState({
			submitted: true,
			error,
		});
	};

	render() {
		const { t } = this.props;
		const { error, start, end, group_id, submitted } = this.state;
		const { detailed_groups } = this.props;

		const optionGroupList =
			detailed_groups.length > 0 &&
			detailed_groups.map((item, i) => {
				let multigroup = item.is_multigroup ? ` (${t('planOpener.multigroup')})` : "";
				return (
					<option key={i} value={item.id}>
						{item.name}
						{multigroup}
					</option>
				);
			}, this);
		return (
			<form onSubmit={this.handleSubmit}>
				<div className="modal-body plan-opener-modal">

					<FormGroup className="form-group" controlId="group_id">
						<FormLabel>{t('planOpener.group')}</FormLabel>
						<FormControl
							value={group_id}
							onChange={this.handleChange}
							isInvalid={submitted && group_id === ""}
							as="select"
						>
							<option value="">{t('planOpener.selectGroup')}</option>
							{optionGroupList}
						</FormControl>
						<FormControl.Feedback type="invalid">
							{t('planOpener.selectGroupError')}
						</FormControl.Feedback>
					</FormGroup>

					<FormGroup
						className={`form-group form-group-periodo ${this.checkInvalidRange() ? "is-invalid" : ""
							}`}
					>
						<FormLabel>{t('planOpener.period')}</FormLabel>
						<DateRangePicker
							startDateId="startDateId"
							endDateId="endDateId"
							startDate={
								start ? moment(start) : null
							}
							endDate={end ? moment(end) : null}
							startDatePlaceholderText={t('common.periodStart')}
							endDatePlaceholderText={t('common.periodEnd')}
							onDatesChange={this.onDatesChange}
							focusedInput={this.state.focusedInput}
							hideKeyboardShortcutsPanel={true}
							isOutsideRange={() => false}
							minimumNights={0}
							onFocusChange={(focusedInput) =>
								this.setState({ focusedInput })
							}
						/>
						<FormControl
							className="hidden"
							isInvalid={this.checkInvalidRange()}
						/>

						<FormControl.Feedback type="invalid">
							{error !== "" ? error : t('planOpener.dateRangeError')}
						</FormControl.Feedback>
					</FormGroup>

					{this.state.error_footer && (
						<InlineAlert variant="error" className="mt15">
							{this.state.error_footer}
						</InlineAlert>
					)}
				</div>

				<div className="modal-footer">
					<button
						type="button"
						onClick={this.props.handleClose}
						className="btn btn-outline-primary"
					>
						{t('common.cancel')}
					</button>
					<SubmitButton
						type="submit"
						isLoading={this.state.isLoading}
						text={t('planOpener.openPlan')}
						loadingText={t('planOpener.opening')}
					/>
				</div>
			</form>
		);
	}
}

const mapStateToProps = (reducers) => {
	return {
		...reducers.groupsReducer,
		loading: reducers.groupsReducer.loading,
		user: reducers.authReducer.user,
	};
};


const mapDispatchToProps = (dispatch) => ({
	getAllGroups: () =>
		dispatch(
			groupsActions.getAllGroups({ sort: "+name", variant: "detailed" })
		),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(EmployeePlanOpener));

